import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import "rc-slider/assets/index.css";
import {
  Input,
  Row,
  ListGroupItem,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
  Button,
  ButtonGroup,
  Collapse,
  Alert,
  DropdownToggle,
  ButtonDropdown,
  DropdownMenu,
  DropdownItem,
  Card,
  Badge,
  CardBody,
  Label,
  Tooltip
} from "reactstrap";
import { units } from "../../../../../common/units";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { DropDownFacade } from "../../../../../components/UI/Buttons/DropDownFacade";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import {
  deepClone,
  setValueToNestedObject,
  getValueFromNestedObject
} from "../../../../../helpers/objectHelper";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { templateHelper } from "../../helpers/templateHelper";
import BoxShadowSettings from "../../../../components/editor/BoxShadowSettings/BoxShadowSettings";


function percentFormatter(v) {
  return `${v} %`;
}

class ContentSettings extends React.Component {
  handleUpdate = template => {
    const { dispatch } = this.props;
    dispatch(templateActions.softUpdate(template));
  };
  handleChange = (color, e, path, fallbackUnit = null) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    let value = templateHelper.getValueFromInput(e, color);
    let unit = templateHelper.getUnit(templateCopy, names);
    if (parseInt(value) && unit.length < 4) {
      value += unit;
    }
    templateCopy.content = deepClone(setValueToNestedObject(
      names,
      value,
      templateCopy.content
    ));
    this.handleUpdate(templateCopy);
  };
  handleUnitChange = (unit, path) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    const value = templateHelper.getValueWithoutUnit(templateCopy, names)
    templateCopy.content = setValueToNestedObject(names, value + unit, templateCopy.content);

    if (unit === "auto") {
      templateCopy.content[names[0]][names[1]] = unit;
    }
    this.handleUpdate(templateCopy);
  };
  render() {
    const { template, device } = this.props;
    if (template === undefined) return null;
    return (
      <div style={{ paddingTop: "10px" }}>
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="BackgroundColor" />
            </Label>
          </Col>
          <Col className="list-setting-item-item">
            <ColorPickerFacade
              color={template && template.content.content.backgroundColor}
              path={"content.backgroundColor"}
              onChange={this.handleChange}
            />
          </Col>
          <br />
        </Row>
        <hr />
        <EditorSlider
          value={
            templateHelper.getValueWithoutUnit(
              template,
              templateHelper.formatToResponsivePath(
                "content",
                "maxWidth",
                device
              )
            )
          }
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["%", "px"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath("content", "maxWidth", device)
          )}
          steps={1}
          max={
            templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath(
                "content",
                "maxWidth",
                device
              )
            ) === "%"
              ? 100
              : 3500
          }
          min={1}
          path={templateHelper.formatToResponsivePath(
            "content",
            "maxWidth",
            device
          )}
          label="MaxWidth"
        />
        <hr />
        <EditorSlider
          value={
            templateHelper.getValueWithoutUnit(
              template,
              templateHelper.formatToResponsivePath(
                "content",
                "minHeight",
                device
              )
            )
          }
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["%", 'vh', 'px']}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath("content", "minHeight", device)
          )}
          steps={1}
          max={
            templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath(
                "content",
                "minHeight",
                device
              )
            ) === "%" || templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath(
                "content",
                "minHeight",
                device
              )
            ) === 'vh'
              ? 100
              : 3500
          }
          min={1}
          path={templateHelper.formatToResponsivePath(
            "content",
            "minHeight",
            device
          )}
          label="MinHeight"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "borderRadius",
              device
            )
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["px", "rem", "%"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "borderRadius",
              device
            )
          )}
          steps={1}
          max={100}
          min={1}
          path={templateHelper.formatToResponsivePath(
            "content",
            "borderRadius",
            device
          )}
          label="BorderRadius"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "marginTop",
              device
            )
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["px", "%"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "marginTop",
              device
            )
          )}
          steps={1}
          max={100}
          min={1}
          path={templateHelper.formatToResponsivePath(
            "content",
            "marginTop",
            device
          )}
          label="MarginTop"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "padding",
              device
            )
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["px", "%"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "padding",
              device
            )
          )}
          steps={1}
          max={100}
          min={1}
          path={templateHelper.formatToResponsivePath(
            "content",
            "padding",
            device
          )}
          label="Padding"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "marginBottom",
              device
            )
          )}
          responsiveSettings={true}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["px", "%"]}
          activeUnit={templateHelper.getUnit(
            template,
            templateHelper.formatToResponsivePath(
              "content",
              "marginBottom",
              device
            )
          )}
          steps={1}
          max={100}
          min={1}
          path={templateHelper.formatToResponsivePath(
            "content",
            "marginBottom",
            device
          )}
          label="MarginBottom"
        />
        <BoxShadowSettings
          boxShadowEnabled={
            (template.content.content.boxShadow !== 'unset'
              && template.content.content.boxShadow !== 'none')}
          value={template.content.content.boxShadow}
          path={'content.boxShadow'}
          onChange={this.handleChange} />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template.template,
    device: state.template.previewDevice
  };
}
export default connect(mapStateToProps)(ContentSettings);
